import axiosIns from '@/libs/axios'

const ROOT_URL = '/strategy-doctor'

export default {
  namespaced: true,
  state: {
    report: null,
    history: [],
    loading: false,
    setupHealth: null,
  },
  getters: {
    report: s => s.report,
    history: s => s.history,
    loading: s => s.loading,
    setupHealth: s => s.setupHealth,
  },
  mutations: {
    SET_REPORT(state, data) { state.report = data },
    SET_HISTORY(state, data) { state.history = data || [] },
    SET_LOADING(state, data) { state.loading = data },
    SET_SETUP_HEALTH(state, data) { state.setupHealth = data },
  },
  actions: {
    getOverview({ commit }) {
      commit('SET_LOADING', true)
      return axiosIns.get(`${ROOT_URL}/overview`)
        .then(response => { commit('SET_REPORT', response.data.data); return response.data.data })
        .finally(() => commit('SET_LOADING', false))
    },
    scan({ commit, dispatch }) {
      commit('SET_LOADING', true)
      return axiosIns.post(`${ROOT_URL}/scan`)
        .then(response => {
          commit('SET_REPORT', response.data.data)
          dispatch('getHistory')
          return response.data.data
        })
        .finally(() => commit('SET_LOADING', false))
    },
    evaluateSetupHealth({ commit }, payload) {
      commit('SET_LOADING', true)
      return axiosIns.post(`${ROOT_URL}/setup-health`, payload)
        .then(response => {
          commit('SET_SETUP_HEALTH', response.data.data)
          return response.data.data
        })
        .finally(() => commit('SET_LOADING', false))
    },
    autoRecover({ commit, dispatch }, payload) {
      commit('SET_LOADING', true)
      return axiosIns.post(`${ROOT_URL}/auto-recover`, payload)
        .then(response => {
          dispatch('getOverview')
          dispatch('getHistory')
          return response.data.data
        })
        .finally(() => commit('SET_LOADING', false))
    },
    getHistory({ commit }, limit = 30) {
      return axiosIns.get(`${ROOT_URL}/history`, { params: { limit } })
        .then(response => { commit('SET_HISTORY', response.data.data); return response.data.data })
    },
  },
}
